import { FieldFunctionOptions, FieldPolicy, TypePolicy } from '@apollo/client'
import {
    ProjectSearch,
    ProjectSearchInput,
} from '@deltek/specification-client/core/Models/project'

export const projectSearchMatchTypePolicy = {
    ProjectSearchMatch: {
        keyFields: ['projectId'],
    } as TypePolicy,
}

export const projectSearchFieldPolicy = {
    projectSearch: {
        keyArgs: (args: Record<string, any> | null) => {
            /*
             *   Exclude top and skip
             *   If included apollo will create a new listing in cache
             *   for each change in top and skip
             */
            const {
                top,
                skip,
                ...uniqueInput
            }: Partial<ProjectSearchInput> = args?.input

            // Unique identifier of list in cache based on the input
            return JSON.stringify({
                orderBy: uniqueInput.orderBy,
                facets: uniqueInput.facets,
                lastUpdatedInPastDays: uniqueInput.lastUpdatedInPastDays,
                isMyCompany: uniqueInput.isMyCompany,
            })
        },
        merge(
            existing: Partial<ProjectSearch> = {},
            incoming: Partial<ProjectSearch>,
            { args }: FieldFunctionOptions
        ) {
            if (args && args.input.skip === 0) {
                // Initial fetch or refetch
                return incoming
            }

            // Pagination
            return {
                ...existing,
                matches: [
                    ...(existing?.matches ?? []),
                    ...(incoming?.matches ?? []),
                ],
            }
        },
    } as FieldPolicy,
}
